import Axios from "axios"
import toastr from "toastr"

export const sendMessage = async (formData: FormData) => {
  try {
    const url = `/api/broadcast-message/send-msg`
    const response = await Axios.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    toastr.success("Broadcast Sent Successfully")
    return response.data
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || error.message || String(error)
    toastr.error("Error Whilte Sending Broadcast Message: " + errorMessage)
    throw error
  }
}